/**
 * @generated SignedSource<<fca366eddf871d2c2494b52c925921fa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ComputeCreditsBase_info$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BillingSettingsButton_info">;
  readonly " $fragmentType": "ComputeCreditsBase_info";
};
export type ComputeCreditsBase_info$key = {
  readonly " $data"?: ComputeCreditsBase_info$data;
  readonly " $fragmentSpreads": FragmentRefs<"ComputeCreditsBase_info">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ComputeCreditsBase_info",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BillingSettingsButton_info"
    }
  ],
  "type": "OwnerInfo",
  "abstractKey": null
};

(node as any).hash = "74b8dfd54835bbe25827eda15a28fb7c";

export default node;
